import { Component, inject } from '@angular/core';
import { ExchangeRateService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ExchangeRateCreateDto,
  ExchangeRateDto,
  ExchangeRateExcelDownloadDto,
  ExchangeRateUpdateDto,
} from '../proxy/controlling/dtos/exchange-rate';
import { EXCHANGERATE_CONFIG, EXCHANGERATE_FIELDS } from './exchange-rate.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-exchange-rate',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ExchangeRateService, ConfirmationService],
  templateUrl: './exchange-rate.html',
  styleUrl: './exchange-rate.scss',
})
export class ExchangeRate extends BaseCrudComponent<
  ExchangeRateDto,
  ExchangeRateCreateDto,
  ExchangeRateUpdateDto,
  ExchangeRateExcelDownloadDto
> {
  service = inject(ExchangeRateService);
  config = EXCHANGERATE_CONFIG;
  fields = EXCHANGERATE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ExchangeRateDto): ExchangeRateUpdateDto {
    return {
      documentDate: data.documentDate,
      value: data.value,
      currencyId: data.currencyId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ExchangeRate';
  }
}
